import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import ClinicDetails from '../../../components/ClinicConfiguration/clinicDetails';
import { useTranslation } from 'react-i18next';
import TemplateModifier from './TemplateModifier/templateModifier';

const PageConfig: React.FC = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const { t } = useTranslation('clinic_config'); // adjust namespace as needed

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        variant="fullWidth"
        aria-label="clinic config tabs"
        TabIndicatorProps={{
          sx: {
            backgroundColor: '#F26440',
            height: 3,
            borderRadius: 2,
          },
        }}
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '16px',
            width: '50%',
            minWidth: '50%',
            maxWidth: '50%',
          },
          '& .Mui-selected': {
            color: '#000',
          },
        }}
      >
        <Tab label={t('Template Modifier')} />
        <Tab label={t('Details')} />
      </Tabs>

      <Box sx={{ mt: 2 }}>
        {tabIndex === 0 && <TemplateModifier />}
        {tabIndex === 1 && <ClinicDetails />}
      </Box>
    </Box>
  );
};

export default PageConfig;
